import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import toast from 'react-hot-toast';
import { FiPlus, FiEdit2, FiTrash2 } from 'react-icons/fi';
import AdminLayout from '../../components/layout/AdminLayout';
import api from '../../utils/api';

const BACKEND = process.env.REACT_APP_BACKEND_URL || '';
const empty = { name:'', position:'', bio:'', email:'', linkedin:'', display_order:0 };

export default function AdminTeam() {
  const [team, setTeam] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(empty);
  const [photo, setPhoto] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const load = () => api.get('/team').then(r=>setTeam(r.data)).catch(()=>{});
  useEffect(()=>{ load(); },[]);

  const openForm = (m=null) => {
    setEditing(m);
    setForm(m?{ name:m.name, position:m.position, bio:m.bio||'', email:m.email||'', linkedin:m.linkedin||'', display_order:m.display_order||0 }:empty);
    setPhoto(null); setShowForm(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); setSubmitting(true);
    try {
      const fd = new FormData();
      Object.entries(form).forEach(([k,v])=>fd.append(k,v));
      if (photo) fd.append('photo', photo);
      if (editing) { await api.put(`/team/${editing.id}`, fd, { headers:{'Content-Type':'multipart/form-data'} }); toast.success('Updated!'); }
      else { await api.post('/team', fd, { headers:{'Content-Type':'multipart/form-data'} }); toast.success('Added!'); }
      setShowForm(false); setEditing(null); load();
    } catch { toast.error('Failed to save'); }
    setSubmitting(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this team member?')) return;
    try { await api.delete(`/team/${id}`); toast.success('Deleted'); load(); }
    catch { toast.error('Failed'); }
  };

  return (
    <AdminLayout title="Manage Team">
      <div style={{ maxWidth:960 }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'1.5rem' }}>
          <p style={{ color:'var(--gray-400)', fontSize:'0.875rem' }}>{team.length} member{team.length!==1?'s':''}</p>
          <button onClick={()=>openForm()} className="btn btn-navy btn-sm"><FiPlus /> Add Member</button>
        </div>

        {showForm && (
          <motion.div initial={{ opacity:0,y:-16 }} animate={{ opacity:1,y:0 }} style={{ background:'white', borderRadius:'16px', padding:'2rem', marginBottom:'2rem', boxShadow:'var(--shadow)', border:'1px solid #E5E7EB' }}>
            <h3 style={{ fontFamily:'Fraunces,serif', color:'var(--navy)', marginBottom:'1.5rem', fontSize:'1.05rem' }}>{editing?'Edit Member':'Add Team Member'}</h3>
            <form onSubmit={handleSubmit}>
              <div className="grid-2">
                <div className="form-group"><label className="form-label">Full Name *</label><input className="form-input" required value={form.name} onChange={e=>setForm({...form,name:e.target.value})} /></div>
                <div className="form-group"><label className="form-label">Position *</label><input className="form-input" required value={form.position} onChange={e=>setForm({...form,position:e.target.value})} /></div>
              </div>
              <div className="form-group"><label className="form-label">Bio</label><textarea className="form-input" value={form.bio} onChange={e=>setForm({...form,bio:e.target.value})} placeholder="Brief biography..." /></div>
              <div className="grid-2">
                <div className="form-group"><label className="form-label">Email</label><input className="form-input" type="email" value={form.email} onChange={e=>setForm({...form,email:e.target.value})} /></div>
                <div className="form-group"><label className="form-label">LinkedIn URL</label><input className="form-input" value={form.linkedin} onChange={e=>setForm({...form,linkedin:e.target.value})} placeholder="https://linkedin.com/in/..." /></div>
              </div>
              <div className="grid-2">
                <div className="form-group"><label className="form-label">Profile Photo</label><input type="file" accept="image/*" onChange={e=>setPhoto(e.target.files[0])} style={{ padding:'0.5rem', border:'1.5px dashed #D1D5DB', borderRadius:'8px', width:'100%', fontSize:'0.83rem' }} /></div>
                <div className="form-group"><label className="form-label">Display Order</label><input className="form-input" type="number" value={form.display_order} onChange={e=>setForm({...form,display_order:+e.target.value})} /></div>
              </div>
              <div style={{ display:'flex', gap:'0.75rem' }}>
                <button type="submit" className="btn btn-navy btn-sm" disabled={submitting}>{submitting?'Saving...':editing?'Update':'Add Member'}</button>
                <button type="button" className="btn btn-sm" style={{ background:'#F3F4F6', color:'var(--gray-600)' }} onClick={()=>{ setShowForm(false); setEditing(null); }}>Cancel</button>
              </div>
            </form>
          </motion.div>
        )}

        <div className="grid-3">
          {team.map((m,i)=>(
            <motion.div key={m.id} initial={{ opacity:0,y:16 }} animate={{ opacity:1,y:0 }} transition={{ delay:i*0.05 }}
              style={{ background:'white', borderRadius:'16px', padding:'1.5rem', boxShadow:'0 1px 4px rgba(0,0,0,0.06)', border:'1px solid #F3F4F6', textAlign:'center' }}>
              {m.photo?<img src={`${BACKEND}${m.photo}`} alt={m.name} style={{ width:84, height:84, borderRadius:'50%', objectFit:'cover', margin:'0 auto 1rem', border:'3px solid var(--gold)' }}/>
                :<div style={{ width:84, height:84, borderRadius:'50%', background:'var(--navy)', margin:'0 auto 1rem', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:'Fraunces,serif', fontSize:'2rem', fontWeight:700, color:'#C9A84C' }}>{m.name?.[0]}</div>}
              <h3 style={{ fontFamily:'Fraunces,serif', fontSize:'0.95rem', color:'var(--navy)', marginBottom:'0.2rem' }}>{m.name}</h3>
              <p style={{ color:'var(--gold)', fontSize:'0.72rem', fontWeight:600, textTransform:'uppercase', letterSpacing:'0.08em', marginBottom:'0.75rem' }}>{m.position}</p>
              {m.bio && <p style={{ color:'var(--gray-400)', fontSize:'0.8rem', lineHeight:1.5, marginBottom:'1rem', display:'-webkit-box', WebkitLineClamp:2, WebkitBoxOrient:'vertical', overflow:'hidden' }}>{m.bio}</p>}
              <div style={{ display:'flex', gap:'0.5rem', justifyContent:'center' }}>
                <button onClick={()=>openForm(m)} style={{ padding:'0.4rem 0.85rem', borderRadius:'7px', background:'#DBEAFE', color:'#1E40AF', border:'none', cursor:'pointer', fontSize:'0.8rem', display:'flex', alignItems:'center', gap:'0.3rem' }}><FiEdit2/>Edit</button>
                <button onClick={()=>handleDelete(m.id)} style={{ padding:'0.4rem 0.85rem', borderRadius:'7px', background:'#FEE2E2', color:'#991B1B', border:'none', cursor:'pointer', fontSize:'0.8rem', display:'flex', alignItems:'center', gap:'0.3rem' }}><FiTrash2/>Delete</button>
              </div>
            </motion.div>
          ))}
          {team.length===0&&!showForm&&<div style={{ gridColumn:'1/-1', textAlign:'center', padding:'4rem', color:'var(--gray-400)' }}><div style={{ fontSize:'3rem', marginBottom:'1rem' }}>👥</div><p>No team members yet.</p></div>}
        </div>
      </div>
    </AdminLayout>
  );
}
